@if (item.url && !item.external) {
	<li [ngClass]="item.classes!" [routerLinkActive]="['active']">
		<a [target]="item.target ? '_blank' : '_self'" [routerLink]="[item.url]" (click)="closeOtherMenu($event)">
			@if (item.icon) {
				<i [className]="item.icon" style="margin-right: 0.5rem"></i> <span class="coded-mtext">{{ item.title }}</span>
			} @else {
				{{ item.title }}
			}
		</a>
	</li>
}
@if (item.url && item.external) {
	<li [ngClass]="item.classes!">
		<a [target]="item.target ? '_blank' : '_self'" [href]="item.url">
			@if (item.icon) {
				<i [className]="item.icon" class="me-2" style="margin-right: 0.5rem"></i>
				<span class="coded-mtext">{{ item.title }}</span>
			} @else {
				{{ item.title }}
			}
		</a>
	</li>
}
